module.exports = __webpack_public_path__ + "static/media/Sharp-LS011B7DH03-Mechanical-Drawing.62d80d7c.png";